<template>
  <div class="not-found-page">
    <div class="content-wrapper">
      <!-- Decorative flowers -->
      <img class="flower flower-top-right" src="/images/flowers.svg" alt="" />
      <img class="flower flower-bottom-left" src="/images/flowers.svg" alt="" />

      <div class="content">
        <!-- 404 Number -->
        <div class="error-code">
          <span class="number">4</span>
          <v-icon class="icon" icon="mdi-gift"> </v-icon>
          <span class="number">4</span>
        </div>

        <!-- Message -->
        <h1 class="title">אופס! הדף לא נמצא</h1>

        <!-- Action Buttons -->
        <div class="actions">
          <v-btn class="home-btn" size="large" elevation="0" to="/">
            <v-icon start>mdi-home</v-icon>
            חזרה לעמוד הבית
          </v-btn>
          <v-btn
            class="products-btn"
            size="large"
            elevation="0"
            variant="outlined"
            to="/products"
          >
            <v-icon start>mdi-package-variant</v-icon>
            לכל המוצרים
          </v-btn>
        </div>

        <!-- Popular Categories -->
        <div class="quick-links">
          <p class="quick-links-title">או בחרו קטגוריה פופולרית:</p>
          <div class="category-chips">
            <v-chip
              v-for="category in popularCategories"
              :key="category.path"
              class="category-chip"
              :to="'/' + category.path"
            >
              {{ category.title }}
            </v-chip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NotFoundPage",
  computed: {
    ...mapGetters({
      getRootCategories: "Category/getRootCategories",
    }),
    popularCategories() {
      // Get first 4 categories or fallback to default ones
      const categories = this.getRootCategories;
      if (categories && categories.length > 0) {
        return categories.slice(0, 4);
      }
      // Fallback categories
      return [
        { title: "מוצרי נוי", path: "decor" },
        { title: "אריזות", path: "packaging" },
        { title: "נרות", path: "candles" },
        { title: "ימי הולדת", path: "birthday" },
      ];
    },
  },
  async mounted() {
    // Load root categories if not already loaded
    if (!this.getRootCategories || this.getRootCategories.length === 0) {
      try {
        await this.$store.dispatch("Category/getRootCategories");
      } catch (error) {
        console.error("Error loading categories:", error);
      }
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
// .not-found-page {
//   min-height: 100vh;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: linear-gradient(135deg, #f5f7fa 0%, #fef9f5 100%);
//   position: relative;
//   overflow: hidden;
//   padding: 40px 20px;
// }
.not-found-page {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #fef9f5 100%);
  padding: 20px;
  box-sizing: border-box; /* Ensures padding doesn't shrink the content */
  height: 100%;
}

.content-wrapper {
  position: relative;
  width: 100%;
  max-width: 800px;
  z-index: 1;
}

// Decorative flowers
.flower {
  position: absolute;
  opacity: 0.5;
  pointer-events: none;
  z-index: 0;

  &.flower-top-right {
    top: -290px;
    right: -220px;
    width: 385px;
    transform: rotate(-28deg);
  }

  &.flower-bottom-left {
    bottom: -110px;
    left: -112px;
    width: 250px;
    transform: rotate(150deg);
  }
}

.content {
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  position: relative;
  z-index: 1;
}

.error-code {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  direction: ltr;

  .number {
    font-size: clamp(80px, 15vw, 120px);
    font-weight: 800;
    color: $primaryColor;
    line-height: 1;
    text-shadow: 0 4px 20px rgba($primaryColor, 0.2);
  }

  .icon {
    font-size: 80px;
    animation: bounce 2s infinite;
    color: $primaryColor !important;
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-20px) rotate(-10deg);
  }
  75% {
    transform: translateY(-10px) rotate(10deg);
  }
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
}

.description {
  font-size: 1.2rem;
  color: #7f8c8d;
  line-height: 1.8;
  margin-bottom: 40px;
}

.actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 50px;

  .home-btn {
    background: $primaryColor !important;
    color: white !important;
    font-weight: 600;
    padding: 0 40px !important;
    height: 50px !important;
    border-radius: 25px !important;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba($primaryColor, 0.3);
    }
  }

  .products-btn {
    border: 2px solid $primaryColor !important;
    color: $primaryColor !important;
    font-weight: 600;
    padding: 0 40px !important;
    height: 50px !important;
    border-radius: 25px !important;
    transition: all 0.3s ease;

    &:hover {
      background: rgba($primaryColor, 0.05) !important;
      transform: translateY(-2px);
    }
  }
}

.quick-links {
  padding-top: 30px;

  .quick-links-title {
    font-size: 1rem;
    color: #7f8c8d;
    margin-bottom: 15px;
    font-weight: 500;
  }

  .category-chips {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;

    .category-chip {
      background: $primaryColor;
      color: white;
      font-weight: 600;
      font-size: 0.95rem;
      padding: 10px 20px;
      height: auto;
      cursor: pointer;
      transition: all 0.3s ease;
      border-radius: 20px;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba($primaryColor, 0.3);
      }
    }
  }
}
</style>
